module.exports = __webpack_public_path__ + "static/footer-84a6435cf3b6319fd2a83b4b9d52f64e.png";